export const environment = {
	production: false,
	// url: "https://api-dealer.policystreet.app",
  // crmUrl: "https://api-crm.policystreet.app",
  // signalrHubUrl: "https://api-crm.policystreet.app/hub",
  url: "https://api-dealer-enc.policystreet.app",
  crmUrl: "https://api-crm-enc.policystreet.app",
  signalrHubUrl: "https://api-crm-enc.policystreet.app/hub",
};
